/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EntitlementsSearch} from '../models/EntitlementsSearch';
import type {EntitlementsSearchRequest} from '../models/EntitlementsSearchRequest';
import type {Error} from '../models/Error';

export interface SearchEntitlementsV2$Request {
    entitlementsSearchRequest: EntitlementsSearchRequest;
}

export interface SearchEntitlementsV2$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchEntitlementsV2Request = createAction<PayloadData<void, SearchEntitlementsV2$Request>>('ENTITLEMENTS_SEARCH_V2__SEARCH_ENTITLEMENTS_V2__REQUEST');
export const searchEntitlementsV2Success = createAction<PayloadData<EntitlementsSearch, SearchEntitlementsV2$Request>>('ENTITLEMENTS_SEARCH_V2__SEARCH_ENTITLEMENTS_V2__SUCCESS');
export const searchEntitlementsV2Failure = createAction<PayloadData<Error, SearchEntitlementsV2$Request, true>>('ENTITLEMENTS_SEARCH_V2__SEARCH_ENTITLEMENTS_V2__FAILURE');

export const searchEntitlementsV2Actions = [
    searchEntitlementsV2Request,
    searchEntitlementsV2Success,
    searchEntitlementsV2Failure
] as const;

/**
 * @param {EntitlementsSearchRequest} meta.entitlementsSearchRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchEntitlementsV2 = (meta: SearchEntitlementsV2$Request, config?: SearchEntitlementsV2$Config) => {
    return {
        CALL_API: {
            types: searchEntitlementsV2Actions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/v2/entitlements/search`,
            TRANSPORT_REQUEST_BODY: meta.entitlementsSearchRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

